import React from "react";

function UpDoubleArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967L17.5303 10.4697C17.8232 10.7626 17.8232 11.2374 17.5303 11.5303C17.2374 11.8232 16.7626 11.8232 16.4697 11.5303L12 7.06066L7.53033 11.5303C7.23744 11.8232 6.76256 11.8232 6.46967 11.5303C6.17678 11.2374 6.17678 10.7626 6.46967 10.4697L11.4697 5.46967ZM6.46967 17.4697L11.4697 12.4697C11.7626 12.1768 12.2374 12.1768 12.5303 12.4697L17.5303 17.4697C17.8232 17.7626 17.8232 18.2374 17.5303 18.5303C17.2374 18.8232 16.7626 18.8232 16.4697 18.5303L12 14.0607L7.53033 18.5303C7.23744 18.8232 6.76256 18.8232 6.46967 18.5303C6.17678 18.2374 6.17678 17.7626 6.46967 17.4697Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoUpDoubleArrow = React.memo(UpDoubleArrow);
export default MemoUpDoubleArrow;
